<template>
    <div id="contact_page">

      <div style="width: 100%; display: flex;justify-content: space-between;padding: 20px">
        <div>

        </div>
        <div class="close"
                            @click="back"><img src="./img/icon_img21.png" /></div>
      </div>
        <p class="tips">点击按钮，即可启动“微信”客户端联系在线客服 </p>
        <span class="btn"><a @click="utils.tokf" target="_blank">联系在线客服</a></span>
        <!-- <p class="tips">或使用微信扫一扫联系客服</p>
        <img src="./img/weixin-contact.png"
             class="wechat" /> -->
    </div>
</template>

<script>
import utils from '../utils';
export default {
    methods: {
        back () {
            this.$router.go(-1)
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#contact_page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow-y: auto;

  .col_btn{
    display: flex;
  }
    .close {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background: #303237;
        padding: 10px;
        cursor: pointer;
        //position: absolute;
        //right: -50px;
        //top: -50px;
    }
    .tips {
        font-size: 18px;
        color: #e3e3e3;
        text-align: center;
        position: relative;
        padding: 0 24px;
    }
    .btn {
        width: 136px;
        text-align: center;
        background: rgb(30, 189, 67);
        border-radius: 4px;
        line-height: 40px;
        font-size: 16px;
        color: #fff;
        margin: 50px 0 70px;
        cursor: pointer;
    }
    .wechat {
        width: 280px;
        margin-top: 20px;
    }
}
</style>